/**
 * cud推荐页面接口列表
 */
 import $http from '../utils/http'// 导入http中创建的axios实例

 const cudRecommend = {
   // 查询公司GCP账户下拉框
   queryGCPAccountBox(params) {
   // return $http.post(`${global.API_URL}/sme/account/queryGCPAccountBox`,params);
    return $http({method:'post',
    url:`${global.API_URL}/sme/account/queryGCPAccountBox?companyId=` + params.companyId
  })
  },
  //查询机型下拉框
  queryInstanceTypeBox(params){
    return $http.post(`${global.API_URL}/sme/gcpRecommend/queryInstanceTypeBox`,params);
  },
  //查询区域下拉框
  queryRegionBox(params){
    return $http.post(`${global.API_URL}/sme/gcpRecommend/queryRegionBox`,params);
  },
  //查询资源类型下拉框
  queryReosurceTypeBox(params){
    return $http.post(`${global.API_URL}/sme/gcpRecommend/queryReosurceTypeBox`,params);
  },
  //查询CUD到期信息列表
  queryCUDExpireList(params){
    return $http.post(`${global.API_URL}/sme/gcpRecommend/queryCUDExpireList`,params);
  },
  //查询已购买CUD数
  queryBoughtNum(params){
    return $http.post(`${global.API_URL}/sme/gcpRecommend/queryBoughtNum`,params);
  },
  //建议购买CUD数
  queryRecommendNum(params){
    return $http.post(`${global.API_URL}/sme/gcpRecommend/queryRecommendNum`,params);
  },
  //查询资源未匹配CUD数量
  queyrUnMaptchNum(params){
    return $http.post(`${global.API_URL}/sme/gcpRecommend/queyrUnMaptchNum`,params);
  },
  //查询资源节省费用
  queryCostSaving(params){
    return $http.post(`${global.API_URL}/sme/gcpRecommend/queryCostSaving`,params);
  },
  //查询CUD使用情况折线图
  checkCudStatistics(params){
    return $http.post(`${global.API_URL}/sme/gcpRecommend/checkCudStatistics`,params);
  }
 }
 
 export default cudRecommend;

 


// WEBPACK FOOTER //
// ./src/api/cudRecommend.js